import { render } from "./UiSection.vue?vue&type=template&id=05c2587e&scoped=true&ts=true"
import script from "./UiSection.vue?vue&type=script&lang=ts"
export * from "./UiSection.vue?vue&type=script&lang=ts"

import "./UiSection.vue?vue&type=style&index=0&id=05c2587e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c2587e"]])

export default __exports__